 import React from 'react';
import {BaseComponent} from "../../../../project/general";
import {render} from "preact";
import {Modal} from "./modal";

class ModalComponent extends BaseComponent {
    showing = false;

    static getNamespace() {
        return 'heritage-modal';
    }

    static getRequiredRefs() {
        return [
            'assetUrl',
            'assetType',
            'toggleOpen'
        ];
    }

    onClickHandler = () => {
        this.showing = !this.showing;
        this.renderModal();
    }

    renderModal() {
        render(
            <Modal showing={this.showing} assetUrl={this.refs.assetUrl.value} assetType={this.refs.assetType.value} onClose={() => this.onClickHandler()}></Modal>,
            this.element
        )
    }

    onInit() {
        this.addListener(this.refs.toggleOpen, 'click', this.onClickHandler);
        this.renderModal();
    }
}

export default ModalComponent;
